import {
    isNodeDeveloper,
    isNodeMainContractor,
    isUserSuperAdmin,
} from "../utils/role";

import { UserRole } from "./userCurrent";

export enum SuperAdminRole {
    PAYER = "Payer",
    BENEFICIARY = "Beneficiary",
}

export enum SuperAdminRoleLow {
    PAYER = "payer",
    BENEFICIARY = "beneficiary",
}

export const superAdminAccountType = (
    currentRoles: UserRole[],
): SuperAdminRole | null => {
    let accountType = null;
    if (isUserSuperAdmin(currentRoles)) {
        if (isNodeDeveloper()) {
            accountType = SuperAdminRole.PAYER;
        }
        if (isNodeMainContractor()) {
            accountType = SuperAdminRole.BENEFICIARY;
        }
    }
    return accountType;
};

export const superAdminAccountTypeLow = (
    currentRoles: UserRole[],
): SuperAdminRoleLow | null => {
    let accountType = null;
    if (isUserSuperAdmin(currentRoles)) {
        if (isNodeDeveloper()) {
            accountType = SuperAdminRoleLow.PAYER;
        }
        if (isNodeMainContractor()) {
            accountType = SuperAdminRoleLow.BENEFICIARY;
        }
    }
    return accountType;
};